export const listSubscriptionItems = `
   query listSubscriptionItems($subscriptionId: ID!, $filter: SubscriptionItemsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listSubscriptionItems(subscriptionId: $subscriptionId, filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              subscriptionId
              priceId
              price {
                id
                productId
                product {
                  name
                }
                amount
                billingPeriod
              }
              quantity
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

// FNP-331: cross-subscription "which subscriptions reference this price" read.
// Backed by price-created-index GSI on BillingTable. Same item shape as
// listSubscriptionItems so the existing RecordsTable rendering carries over.
export const listSubscriptionItemsByPrice = `
   query listSubscriptionItemsByPrice($priceId: ID!, $limit: Int, $nextToken: String, $sort: SortInput) {
       listSubscriptionItemsByPrice(priceId: $priceId, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              subscriptionId
              priceId
              price {
                id
                productId
                product {
                  name
                }
                amount
                billingPeriod
              }
              quantity
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getSubscriptionItem($id:ID!) {
       getSubscriptionItem(id:$id) {
        id
        subscriptionId
        priceId
        quantity
        createdByUsername
        created
        updated
       } 
}`;
